import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { RootState } from '@@/store';
import NavBar from '@@/components/NavBar';
import Sidebar from '@@/components/Sidebar';

const PrivateRoute: React.FC = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.accessToken) {
      navigate('/');
    }
  }, [auth.accessToken, navigate]);

  return (
    <div className="flex flex-row flex-grow bg-slate-50 w-full">
      <div className="flex flex-col flex-grow">
        <NavBar />
        <div className="flex flex-row h-screen">
          <Sidebar />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PrivateRoute;
